/*
https://github.com/themesberg/flowbite-icons
Flowbite Icons is free and open-source under the MIT License.
*/
import React from 'react';

interface Props {
    readonly className?: string;
}

export default function FolderSolid({
    className = null,
}: Props) {
    return (
        <svg className={className} xmlns="http://www.w3.org/2000/svg" width="20" height="21" viewBox="0 0 20 21" fill="none">
            <path d="M2.67038 19.5H15.793L20 9.97059H5.25873L1.70909 18.0113C1.63794 18.1725 1.60794 18.3491 1.6218 18.5249C1.63566 18.7008 1.69294 18.8704 1.78845 19.0183C1.88395 19.1662 2.01465 19.2877 2.16867 19.3718C2.32269 19.456 2.49515 19.5 2.67038 19.5Z" fill="currentColor" />
            <path d="M3.33614 9.11082C3.50138 8.73638 3.77096 8.41824 4.11222 8.19497C4.45347 7.9717 4.85174 7.85289 5.25873 7.85294H18.9314C18.9314 7.29131 18.7098 6.75268 18.3153 6.35554C17.9208 5.9584 17.3858 5.73529 16.8279 5.73529H12.0351L9.51094 2.34706C9.3145 2.0846 9.06033 1.87153 8.76836 1.72457C8.47639 1.5776 8.15457 1.50074 7.82815 1.5H2.10349C1.54561 1.5 1.01058 1.72311 0.616098 2.12024C0.221617 2.51738 0 3.05601 0 3.61765V16.6687L3.33614 9.11082Z" fill="currentColor" />
        </svg>
    );
}
